<div class="app-payment-transactions">
    <div fxLayout="row wrap" *ngIf="isMobile && !isPaymentSuccess" class="p-20">
        <div fxFlex="100%" class="mb-5 fw-600 mt-20">Summary</div>
        <div fxLayoutAlign="start center" fxFlex="50%">Items
            <!-- <span *ngIf="incl" style="font-size: 12px;margin-left: 5px;margin-top: 5px;"> (Incl. VAT)</span> -->
        </div>
        <div fxLayoutAlign="end center" fxFlex="50%">
            {{amount | currency:userCurrency}}</div>

        <div fxLayoutAlign="start center" fxFlex="50%"
            *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')">Processing Fee
        </div>
        <div fxLayoutAlign="end center" fxFlex="50%"
            *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')">
            {{processingFee | currency:userCurrency}}
        </div>
        <div fxLayoutAlign="start center" fxFlex="50%" class="mt-10 pt-10 fs-20 total-row">Total</div>
        <div fxLayoutAlign="end center" fxFlex="50%" class="amount notranslate mt-10 pt-10 fs-20 total-row">
            <span *ngIf="selectedTransaction =='ott' || !selectedTransaction">{{finalVal |
                currency:userCurrency}}</span>
            <span *ngIf="selectedTransaction =='wallet'">{{amount | currency:userCurrency}}</span>
        </div>
    </div>
    <div *ngIf="isPaymentSuccess" class="p-30" fxLayout="column">
        <div fxFlex="100%" fxLayoutAlign="center center" class="text-center text-white">
            Payment completed Successfully. Go to the application.
        </div>
        <div class="text-center mt-20" fxFlex="100%" fxLayoutAlign="center center">
            <a class="flat-primary-button primary-bg-button" target="_other" rel="nofollow" [href]="channelUrl">
                Go To Channel
            </a>
        </div>
    </div>
    <ng-container *ngIf="!isPaymentSuccess">
        <div class="disable-note" *ngIf="!enableTransactions">
            Please fill all the required fields to select a payment method
        </div>
        <mat-radio-group [(ngModel)]="selectedTransaction">
            <!-- START CRYPTO SECTION -->
            <div *ngIf="deviceInfo == 'web' && isCryptoWallet==1">
                <div class="row align-items-center radio-con no-gutters"
                    [ngClass]="{'radio-con-active': selectedTransaction == 'crypto'}"
                    [ngStyle]="{
                        'border': selectedTransaction === 'crypto' && settingsData?.font_tertiary_color 
                                  ? '2px solid ' + settingsData.font_tertiary_color : null,
                        'background-color': settingsData?.bg_tertiary_color 
                                  ? settingsData?.bg_tertiary_color : null }">
                    <div class="col-8">
                        <span class="pay-name" [ngStyle]="{'color':settingsData?.font_tertiary_color}">Crypto Wallet</span><span class="pay-info ml-1">
                            <!-- <app-svg [icon]="'information'"></app-svg> -->
                        </span>
                    </div>
                    <div class="col-4 text-right" [style.--radio-border-color]="settingsData?.font_tertiary_color" [style.--radio-label-color]="settingsData?.font_tertiary_color">
                        <mat-radio-button (change)="getvalue($event)" value="crypto" [disabled]="!enableTransactions" >
                        </mat-radio-button>
                    </div>
                </div>
                <ng-container *ngIf=" selectedTransaction == 'crypto'">
                    <div class="wallet-container"
                    [ngStyle]="{'background-color':settingsData?.bg_tertiary_color,'color':settingsData?.font_tertiary_color}">
                        <div class="d-flex justify-content-between mb-2">
                            <div class="fs-18 font-weight-bold">Total Amount:</div>
                            <div class="mb-1 font-weight-bold fs-18 d-flex" *ngIf="!nftTickets"><span><img
                                        src="{{cryptoSymbol}}" width="19" class="mr-1 mb-1" /></span>{{crypto_amt}}
                                {{cryptoToken}}</div>
                            <div class="mb-1 font-weight-bold fs-18 d-flex" *ngIf="nftTickets"><span><img
                                        src="{{cryptoSymbol}}" width="19" class="mr-1 mb-1" /></span>{{nftTicketPrice}}
                                {{cryptoToken}}</div>
                        </div>

                        <div [hidden]="metamaskinstalled">
                            <p>Please Install METAMASK to continue with Crypto Payments.</p>
                            <div class="pt-2 pb-2 connect-metamask">
                                <img src="assets/metamask.svg" />
                                <a href="https://metamask.io/download/" target="_blank" class="ml-3 metamask-link">Get
                                    MetaMask</a>
                            </div>
                        </div>
                        <div class="c-wallet p-0" *ngIf="metamaskinstalled && walletID">
                            <div class="w-50 mb-1">
                                <span class="wc-h" [ngStyle]="{'color':settingsData?.font_tertiary_color}">Your Metamask wallet:</span>
                            </div>

                            <div class="wallet-id">
                                <div class="code p-10">{{ walletID}}</div>
                                <i class="fa fa-copy mini-fab-button pull-right fs-25 pointer"
                                    (click)="copywalletvalue()"></i>
                            </div>
                        </div>
                        <div class="d-flex flex-column align-items-start w-100" *ngIf="metamaskinstalled && walletID">
                            <div class="wallet-container mt-0 w-100 token-padding"
                            [ngStyle]="{'background-color':settingsData?.bg_secondary_color}">
                                <mat-form-field appearance="fill" class="w-100 mb-10" [style.--form-border-color]="settingsData?.font_secondary_color" [style.--before-border-color]="settingsData?.font_secondary_color"
                                >
                                    <mat-label [ngStyle]="{'color':settingsData?.font_secondary_color}">Choose Token</mat-label>
                                    <mat-select [(ngModel)]="selectedToken" panelClass="custom-panel"
                                        (selectionChange)="onTokenSelect($event.value)" [ngStyle]="{'background-color':settingsData?.bg_secondary_color}">
                                        <mat-option [value]="'KO+'" [ngStyle]="{'--mat-option-selected-state-label-text-color': settingsData?.font_secondary_color,
                                        '--mat-pseudo-checkbox-color': settingsData?.font_secondary_color}">{{clientDetails?.name=="BigbeeAI"?"BB":"KO+"}}</mat-option>
                                        <mat-option [value]="'GFL'" [ngStyle]="{'--mat-option-selected-state-label-text-color': settingsData?.font_secondary_color,
                                        '--mat-pseudo-checkbox-color': settingsData?.font_secondary_color}">GFL</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="selectedToken" class="w-100">
                                <!-- <div class="w-100 bal-con token-balance-container">
                                    <span class="wc-ab align-self-middle mb-1 d-block">Available Balance:</span>
                                    <span class="d-block mb-1">
                                        <img src="{{cryptoSymbol}}" class="mr-1" />
                                    </span>
                                    <span class="ml-1 d-block mb-1" matTooltip="{{available_balance}}">{{crypto_balance}}
                                    </span>
                                    <span class="align-self-middle d-block ml-2">{{selectedToken=="KO+"?clientDetails?.name=="BigbeeAI"?"BB":"KO+":"GFL"}}</span>
                                </div> -->
                                <div class="d-flex justify-content-between mb-2">
                                    <div class="fs-18 font-weight-bold">Available Balance:</div>
                                    <div class="mb-1 font-weight-bold fs-18 d-flex">
                                        <span class="d-block mb-1">
                                            <img  width="19" class="mr-1 mb-1" src="{{cryptoSymbol}}"  />
                                        </span>
                                        <span class="ml-1 d-block mb-1" matTooltip="{{available_balance}}">{{crypto_balance}}
                                        </span>
                                        <span class="align-self-middle d-block ml-2">{{selectedToken=="KO+"?clientDetails?.name=="BigbeeAI"?"BB":"KO+":"GFL"}}</span>
                                    </div>
                                </div>
                                <div *ngIf="isRunningOutOfTokens" class="warning-message" [ngStyle]="{'background-color':settingsData?.bg_secondary_color,'border':'1px solid' + settingsData?.bg_secondary_color}">
                                    <mat-icon class="warning-icon" color="warn" [ngStyle]="{'color':settingsData?.font_secondary_color}">error_outline</mat-icon>
                                    <span class="warning-text" [ngStyle]="{'color':settingsData?.font_secondary_color}">Running out of tokens</span>
                                    <button mat-flat-button color="primary" class="flat-primary-button tertiary-bg-button" [attr.style]="
                                    (settingsData?.bg_primary_color ? 'background-color: ' + settingsData.bg_primary_color + ' !important; ' : '') +
                                    (settingsData?.font_primary_color ? 'color: ' + settingsData.font_primary_color + ' !important;' : '')
                                    " (click)="convertTokens()">Exchange Tokens</button>
                                </div>
                                <p *ngIf="isRunningOutOfTokens" class="or-divider">or</p>
                            </div>
                        </div>
                        <!-- <mat-form-field class="w-250 mb-10" *ngIf="metamaskinstalled && walletID">
                            <mat-label>Enter amount</mat-label>
                            <input matInput allowValues autofocus="autofocus" isInputType="number"
                                isInputType="decimalWithTwoDigits" min="0" step="1" max="1000" [(ngModel)] = "amount" required>
                        </mat-form-field> -->
                        <div *ngIf="selectedToken && add_amt_to_crypto_wallet">
                            <form [formGroup]="cryptoForm" class="app-tertiary-bg d-flex">
                                <mat-form-field class="w-250 mb-10" [style.--radio-border-color]="settingsData?.main_bg_color" [style.--form-border-color]="settingsData?.font_tertiary_color" [style.--before-border-color]="settingsData?.font_tertiary_color">
                                    <mat-label [ngStyle]="{'color':settingsData?.font_tertiary_color}">Enter amount<span *ngIf="convRate">(1 {{walletInfo?.currency |
                                            currencySymbol}} equivalent to {{convRate}})</span></mat-label>
                                    <input matInput allowValues autofocus="autofocus" isInputType="number"
                                        isInputType="decimalWithTwoDigits" min="0" step="1"
                                        (blur)="onCryptoAmtChange($event.target.value)" formControlName="crypto_amount"
                                        required [style.color]="settingsData?.font_tertiary_color +'!important'">
                                    <span matSuffix [style.color]="settingsData?.font_tertiary_color +'!important'">
                                        {{cryptoToken}}
                                    </span>
                                    <!-- <span matPrefix *ngIf="walletInfo?.currency">{{walletInfo?.currency |
                                        currencySymbol}}&nbsp;</span>
                                    <span matPrefix *ngIf="!walletInfo?.currency">{{currency_for_totAmt |
                                        currencySymbol}}&nbsp;</span> -->
                                    <mat-error *ngIf="cryptoForm.get('crypto_amount').hasError('required')">
                                        Please enter amount
                                    </mat-error>
                                </mat-form-field>
                                <div class="d-flex align-items-center ml-15 mb-15">
                                    <span *ngIf="nftTickets">({{chainNetwork}}) </span><span
                                        class="ml-5">{{crypto_amt_in_user_cur | currency : getCurrency}}</span>
                                </div>
                            </form>
                            <div class="row pb-10" *ngIf="add_amt_to_crypto_wallet">
                                <div class="col-8">
                                    Processing Fee
                                </div>
                                <div class="col-3 text-right">
                                    {{ crypto_pf | currency : getCurrency}}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="selectedToken">
                            <div [hidden]="!newCardForCrypto && !add_amt_to_crypto_wallet">
                                <app-saved-cards [settingsData]="settingsData" [selectedTransaction]="selectedTransaction">
                                </app-saved-cards>
                                <ng-container *ngIf="savedCardsList?.length > 0">
                                    <button mat-flat-button
                                        class="btn flat-primary-button mr-2 br-3 mt-5 mb-20 tertiary-bg-button"
                                        [style.background-color]="settingsData?.bg_secondary_color+ ' !important'"
                                        [style.color]="settingsData?.font_secondary_color + ' !important'"
                                        (click)="addCardForCrypto()">
                                        <i class="fa fa-plus pr-5" aria-hidden="true"></i>
                                        Another Credit/Debit card
                                    </button>
                                </ng-container>
                                <form class="display-block" [hidden]="!addNewCard" (ngSubmit)="completeOttPayment()"
                                    class="checkout">
                                    <div id="form-field">
                                        <div fxFlex="100%" class="text-center" fxLayout="column">
                                            <div id="card-info" class="mb-20" #cardInfo></div>
                                            <mat-error id="card-errors" role="alert" *ngIf="cardError" class="mb-20">
                                                <mat-icon class="c-error">cancel</mat-icon>
                                                &nbsp;{{ cardError }}
                                            </mat-error>
                                            <div class="text-left checkbox app-merchandise app-tertiary-bg">
                                                <mat-checkbox name="saveCard" class="fw-300 t_c_checkBox"
                                                [style.--checkbox-color]="settingsData?.font_tertiary_color"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="save_card"
                                                    (change)="saveCard($event)">
                                                </mat-checkbox><span> Save card for future payments</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="button-container" *ngIf="metamaskinstalled">
                                <button mat-flat-button class="action-button flat-secondary-button" (click)="addFundsToCrypto()"
                                [style.color]="settingsData?.bg_primary_color + '!important'"
                                [style.border]="'1px solid ' + settingsData?.bg_primary_color"
                                [style.background-color]="settingsData?.font_primary_color + ' !important'"
                                    *ngIf="add_amt_to_crypto_wallet">Add Funds</button>
                                <button mat-flat-button fxHide.xs="true" fxShow *ngIf="add_amt_to_crypto_wallet"
                                    class="action-button cancel-button flat-primary-button tertiary-bg-btn1 secondary-button-color"
                                    [style.color]="settingsData?.bg_primary_color + '!important'"
                                    [style.border]="'1px solid ' + settingsData?.bg_primary_color"
                                    [style.background-color]="settingsData?.font_primary_color + ' !important'"
                                    (click)="redirectTo()">Cancel</button>
                                <button mat-flat-button class="action-button flat-primary-button tertiary-bg-button"
                                [style.background-color]="settingsData?.bg_primary_color+ ' !important'"
                                [style.color]="settingsData?.font_primary_color + ' !important'"
                                    *ngIf="!nftTickets" [disabled]="isPayment" (click)="completeCryptoPayment()">
                                    <span *ngIf="activeBlock == 'Tips'">Tip</span>
                                    <span *ngIf="activeBlock == 'Donations'">Donate</span>
                                    <span *ngIf="currentBlock == 'Subscribe'">Subscribe</span>
                                    <span *ngIf="currentBlock == 'Merch Market' || currentBlock == 'Merchandise' || currentBlock =='PPV' || currentBlock == 'Tickets'">Place Order</span>
                                </button>
                                <button mat-flat-button class="action-button flat-primary-button tertiary-bg-button"
                                    [disabled]="!enableTransactions" *ngIf="currentBlock == 'Tickets' && nftTickets"
                                    (click)="onNFTTicketBuy()" [style.background-color]="settingsData?.bg_primary_color+ ' !important'"
                                    [style.color]="settingsData?.font_primary_color + ' !important'">
                                    <span>Place Order</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <!-- END CRYPTO SECTION -->

            <!-- CASH SECTION -->
            <div [hidden]="nftTickets && this.currentBlock == 'Tickets'">
                <div class="row align-items-center radio-con no-gutters"
                    [ngClass]="{'radio-con-active': selectedTransaction == 'wallet'}"
                    [attr.style]="
                    (selectedTransaction === 'wallet' && settingsData?.font_tertiary_color ? 'border: 2px solid ' + settingsData.font_tertiary_color + ' !important; ' : '') +
                    (settingsData?.bg_tertiary_color ? 'background-color: ' + settingsData.bg_tertiary_color + ' !important;' : '')">
                    <div class="col-9">
                        <span class="pay-name" [ngStyle]="{'color':settingsData?.font_tertiary_color}">Cash Wallet</span><span class="pay-info ml-1 ">
                            <!-- <app-svg [icon]="'information'"></app-svg> -->
                        </span>
                    </div>
                    <div class="col-3 text-right"  [style.--radio-border-color]="settingsData?.font_tertiary_color" [style.--radio-label-color]="settingsData?.font_tertiary_color">
                        <mat-radio-button (change)="getvalue($event)" value="wallet" [disabled]="!enableTransactions" class="custom-radio" >
                        </mat-radio-button>
                    </div>
                </div>
                <ng-container *ngIf=" selectedTransaction == 'wallet'">
                    <div class="wallet-container p-2 bg-dark" [ngClass]="{'w-block':router.url.includes('/stream/')}"
                    [attr.style]="
                    (settingsData?.bg_tertiary_color ? 'background-color: ' + settingsData.bg_tertiary_color + ' !important; ' : '') +
                    (settingsData?.font_tertiary_color ? 'color: ' + settingsData.font_tertiary_color + ' !important;' : '')">
                        <span>Your cash wallet:</span>
                        <div class="copy-con1" [ngStyle]="{'border':'1px solid'+ settingsData?.font_tertiary_color}">
                            <div class="ab-f">
                                <div class="copy-code-ab mt-0">
                                    Available Balance
                                </div>
                                <div class="amt-div" [ngStyle]="{'color':settingsData?.font_tertiary_color}">
                                    <span class="align-middle" *ngIf="walletInfo?.currency">{{walletInfo?.amount |
                                        currency:walletInfo?.currency}}</span>
                                    <span class="align-middle" *ngIf="!walletInfo?.currency">{{0.00
                                        | currency:currency_for_totAmt}}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="add_amt_to_wallet">
                            <form [formGroup]="cashWalletForm" class="app-tertiary-bg">
                                <mat-form-field class="prefix-val w-250 mb-10" [style.--radio-border-color]="settingsData?.font_tertiary_color" [style.--form-border-color]="settingsData?.font_tertiary_color" [style.--before-border-color]="settingsData?.font_tertiary_color"
                                >
                                    <mat-label [ngStyle]="{'color':settingsData?.font_tertiary_color}">Enter amount<span *ngIf="convRate">(1 {{walletInfo?.currency |
                                            currencySymbol}} equivalent to {{convRate}})</span></mat-label>
                                    <input matInput allowValues autofocus="autofocus" isInputType="number" [style.color]="settingsData?.font_tertiary_color +'!important'"
                                        isInputType="decimalWithTwoDigits" min="0" step="1"
                                        (blur)="onAmountChange($event.target.value)" formControlName="amount" required [style.color]="settingsData?.font_tertiary_color +'!important'">
                                    <span matPrefix *ngIf="walletInfo?.currency">{{walletInfo?.currency |
                                        currencySymbol}}&nbsp;</span>
                                    <span matPrefix *ngIf="!walletInfo?.currency">{{currency_for_totAmt |
                                        currencySymbol}}&nbsp;</span>
                                    <mat-error *ngIf="cashWalletForm.get('amount').hasError('required')">
                                        Please enter amount
                                    </mat-error>
                                </mat-form-field>
                            </form>
                            <div class="row pb-10" *ngIf="wallet_pf">
                                <div class="col-8">
                                    Processing Fee
                                </div>
                                <div class="col-3 text-right">
                                    {{wallet_pf | currency:walletInfo?.currency ? walletInfo?.currency :
                                    currency_for_totAmt}}
                                </div>
                            </div>
                        </div>
                        <div [hidden]="!dispSavedCards">
                            <app-saved-cards [settingsData]="settingsData" [selectedTransaction]="selectedTransaction">
                            </app-saved-cards>
                            <ng-container *ngIf="savedCardsList?.length > 0">
                                <button mat-flat-button
                                    class="btn flat-primary-button mr-2 br-3 mt-5 tertiary-bg-button"
                                    [style.background-color]="settingsData?.bg_secondary_color+ ' !important'"
                                    [style.color]="settingsData?.font_secondary_color + ' !important'"
                                    (click)="newCard()">
                                    <i class="fa fa-plus pr-5" aria-hidden="true"></i>
                                    Another Credit/Debit card
                                </button>
                            </ng-container>
                            <form class="display-block" (ngSubmit)="makePayment('stripe')" class="checkout"
                                [hidden]="!addNewCard">
                                <div id="form-field">
                                    <div fxFlex="100%" class="text-center" fxLayout="column">
                                        <div id="card-info" class="mb-20" #cardInfo></div>
                                        <mat-error id="card-errors" role="alert" *ngIf="cardError" class="mb-20">
                                            <mat-icon class="c-error">cancel
                                            </mat-icon>
                                            &nbsp;{{ cardError }}
                                        </mat-error>
                                        <div class="text-left checkbox  app-merchandise app-tertiary-bg">
                                            <mat-checkbox name="saveCard" class="fw-300 t_c_checkBox"
                                            [style.--checkbox-color]="settingsData?.font_tertiary_color"
                                                [ngModelOptions]="{standalone: true}" [(ngModel)]="save_card"
                                                (change)="saveCard($event)">
                                            </mat-checkbox><span> Save card for future payments</span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="text-center mt-20 mb-20">
                            <button mat-flat-button class=" btn tertiary-bg-btn1 flat-secondary-button mr-20"
                            [style.color]="settingsData?.bg_primary_color + '!important'"
                            [style.border]="'1px solid ' + settingsData?.bg_primary_color"
                                (click)="addFunds()" *ngIf="!addNewCard && !dispSavedCards && (add_amt_to_wallet)">Add
                                Funds</button>
                            <button mat-flat-button fxHide.xs="true" fxShow *ngIf="addNewCard || dispSavedCards"
                                class="flat-primary-button tertiary-bg-btn1 mr-20 cancel-l-btn secondary-button-color"
                                [style.color]="settingsData?.bg_primary_color + '!important'"
                                [style.border]="'1px solid ' + settingsData?.bg_primary_color"
                                [style.background-color]="settingsData?.font_primary_color + '!important'"
                                (click)="redirectTo()">Cancel</button>
                            <a class="flat-primary-button plr-15 ptb-10 mr-20 tertiary-bg-btn1" fxShow.xs="true" fxHide
                                [style.color]="settingsData?.bg_primary_color + '!important'"
                                [style.background-color]="settingsData?.font_primary_color + '!important'"
                                [style.border]="'1px solid ' + settingsData?.bg_primary_color"
                                target="_other" *ngIf="addNewCard || dispSavedCards" rel="nofollow"
                                (click)="mobileLinks()">Cancel</a>
                            <button mat-flat-button class=" btn flat-primary-button tertiary-bg-button"
                            [style.background-color]="settingsData?.bg_primary_color+ ' !important'"
                            [style.color]="settingsData?.font_primary_color + ' !important'"
                                [disabled]="isPayment" (click)="placeOrder()">
                                <span *ngIf="activeBlock == 'Tips'">Tip {{finalVal | currency:walletInfo?.currency
                                    ? walletInfo?.currency : currency_for_totAmt}}</span>
                                <span *ngIf="activeBlock == 'Donations'">Donate {{finalVal | currency:
                                    walletInfo?.currency ? walletInfo?.currency : currency_for_totAmt}}</span>
                                <!-- <span *ngIf="currentBlock == 'Subscribe'">Subscribe {{amt_without_pf |
                                    currency:walletInfo?.currency ? walletInfo?.currency : currency_for_totAmt}}</span> -->
                                    <span *ngIf="currentBlock == 'Subscribe'">Subscribe {{finalVal |
                                        currency:walletInfo?.currency ? walletInfo?.currency : currency_for_totAmt}}</span>
                                <!-- <span
                                    *ngIf="currentBlock == 'Merch Market' || currentBlock == 'Merchandise' || currentBlock =='PPV' || currentBlock == 'Tickets'">Place
                                    Order {{amt_without_pf | currency:walletInfo?.currency ? walletInfo?.currency :
                                    currency_for_totAmt}}</span> -->
                                    <span
                                    *ngIf="currentBlock == 'Merch Market' || currentBlock == 'Merchandise' || currentBlock =='PPV' || currentBlock == 'Tickets'">Place
                                    Order {{finalVal | currency:walletInfo?.currency ? walletInfo?.currency :
                                    currency_for_totAmt}}</span>
                            </button>
                        </div>
                    </div>
                </ng-container>

            </div>
            <!-- CASH SECTION -->

            <!-- OTT SECTION -->
            <div [hidden]="nftTickets && this.currentBlock == 'Tickets'">
                <div class="row align-items-center radio-con no-gutters"
                    [ngClass]="{'radio-con-active': selectedTransaction == 'ott'}"
                    [attr.style]="
                    (selectedTransaction === 'ott' && settingsData?.font_tertiary_color ? 'border: 2px solid ' + settingsData.font_tertiary_color + ' !important; ' : '') +
                    (settingsData?.bg_tertiary_color ? 'background-color: ' + settingsData.bg_tertiary_color + ' !important;' : '')">

                    <div class="col-9" >
                        <span class="pay-name" [ngStyle]="{'color':settingsData?.font_tertiary_color}">one time transaction</span>
                        <span class="pay-info ml-1 ">
                            <!-- <app-svg [icon]="'information'"></app-svg> -->
                        </span>
                    </div>
                    <div class="col-3 text-right" [style.--radio-border-color]="settingsData?.font_tertiary_color" [style.--radio-label-color]="settingsData?.font_tertiary_color">
                        <mat-radio-button (change)="getvalue($event)" value="ott" [disabled]="!enableTransactions" >
                        </mat-radio-button>
                    </div>
                </div>
                <ng-container *ngIf=" selectedTransaction == 'ott'">
                    <div class="wallet-container p-2 bg-dark" [ngClass]="{'w-block':router.url.includes('/stream/')}"
                    [attr.style]="settingsData?.bg_tertiary_color ? 'background-color: ' + settingsData.bg_tertiary_color + ' !important;' : '' ">
                        <app-saved-cards [settingsData]="settingsData" [selectedTransaction]="selectedTransaction">
                        </app-saved-cards>
                        <ng-container *ngIf="savedCardsList?.length > 0">
                            <button mat-flat-button
                                class=" btn flat-primary-button mr-2 br-3 mt-5 mb-20 tertiary-bg-button"
                                [style.background-color]="settingsData?.bg_secondary_color+ ' !important'"
                                [style.color]="settingsData?.font_secondary_color + ' !important'"
                                (click)="newCard()">
                                <i class="fa fa-plus pr-5" aria-hidden="true"></i>
                                Another Credit/Debit card
                            </button>
                        </ng-container>
                        <form class="display-block" (ngSubmit)="completeOttPayment()" class="checkout"
                            [hidden]="!addNewCard">
                            <div id="form-field">
                                <div fxFlex="100%" class="text-center" fxLayout="column">
                                    <div id="card-info" class="mb-20" #cardInfo></div>
                                    <mat-error id="card-errors" role="alert" *ngIf="cardError" class="mb-20">
                                        <mat-icon class="c-error">cancel
                                        </mat-icon>
                                        &nbsp;{{ cardError }}
                                    </mat-error>
                                    <div class="text-left checkbox app-merchandise app-tertiary-bg" [ngStyle]="{'color':settingsData?.font_tertiary_color}">
                                        <mat-checkbox name="saveCard" class="fw-300 t_c_checkBox"
                                        [style.--checkbox-color]="settingsData?.font_tertiary_color"
                                            [ngModelOptions]="{standalone: true}" [(ngModel)]="save_card"
                                            (change)="saveCard($event)">
                                        </mat-checkbox><span> Save card for future payments</span>
                                    </div>
                                </div>

                            </div>
                        </form>
                        <div class="text-center py-4">
                            <button mat-flat-button fxHide.xs="true" fxShow
                                class="flat-primary-button tertiary-bg-btn1 mr-20 cancel-l-btn secondary-button-color"
                                [style.color]="settingsData?.bg_primary_color + '!important'"
                                [style.border]="'1px solid ' + settingsData?.bg_primary_color"
                                [style.background-color]="settingsData?.font_primary_color + '!important'"
                                (click)="redirectTo()">Cancel</button>
                            <a class="flat-primary-button tertiary-bg-btn1 plr-15 ptb-10 mr-20 tertiary-bg-btn1"
                            [style.color]="settingsData?.bg_primary_color + '!important'"
                            [style.border]="'1px solid ' + settingsData?.bg_primary_color"
                            [style.background-color]="settingsData?.font_primary_color + ' !important'"
                                fxShow.xs="true" fxHide target="_other" rel="nofollow"
                                (click)="mobileLinks()">Cancel</a>
                            <button mat-flat-button class=" btn flat-primary-button tertiary-bg-button"
                            [style.background-color]="settingsData?.bg_primary_color+ ' !important'"
                            [style.color]="settingsData?.font_primary_color + ' !important'"
                                [disabled]="isPayment || settingsData?.is_preview" (click)="completeOttPayment()">
                                <!-- <span *ngIf="activeBlock == 'Tips'">Tip {{amt_without_pf |
                                    currency:currency_for_totAmt}}</span> -->
                                <span *ngIf="activeBlock == 'Tips'">Tip {{finalVal |
                                    currency:currency_for_totAmt}}</span>
                                <span *ngIf="activeBlock == 'Donations'">Donate {{finalVal |
                                    currency:currency_for_totAmt}}</span>
                                <span *ngIf="currentBlock == 'Subscribe'">Subscribe {{finalVal |
                                    currency:currency_for_totAmt}}</span>
                                <span
                                    *ngIf="currentBlock == 'Merch Market' || currentBlock == 'Merchandise' || currentBlock =='PPV' || currentBlock == 'Tickets'">Place
                                    Order {{finalVal | currency:currency_for_totAmt}}</span>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
            <!-- OTT SECTION -->